/**
 * Extract a user-facing message from a project date range validation API error.
 *
 * @param {import('axios').AxiosError|Error} err
 * @param {string} [fallback]
 * @returns {string}
 */
export function getProjectDateRangeErrorMessage(
  err,
  fallback = 'Operation failed'
) {
  const data = err?.response?.data;
  if (data?.error === 'Project date range validation failed' && data?.detail) {
    return String(data.detail);
  }
  return data?.message || err?.message || fallback;
}
